"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SlidesWrapper = exports.Slides = exports.Slide = exports.Dots = exports.DotCarouselRoot = exports.Dot = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _colors = require("../colors");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/* private/atomic */
var CenterContent = _styledComponents["default"].div.withConfig({
  displayName: "styles__CenterContent",
  componentId: "sc-n66423-0"
})(["display:flex;flex-direction:row;justify-content:center;align-items:center;"]);

// dirty hack since it's 2020 and there's no official way to hide the scroll bar
var HideScrollbarX = _styledComponents["default"].div.withConfig({
  displayName: "styles__HideScrollbarX",
  componentId: "sc-n66423-1"
})(["overflow:hidden;& > *{margin-bottom:-20px;padding-bottom:20px;}"]);

/* public */
var Slide = _styledComponents["default"].section.withConfig({
  displayName: "styles__Slide",
  componentId: "sc-n66423-2"
})([""]);
exports.Slide = Slide;
var Slides = _styledComponents["default"].div.withConfig({
  displayName: "styles__Slides",
  componentId: "sc-n66423-3"
})(["display:flex;flex-direction:row;overflow-x:scroll;"]);
exports.Slides = Slides;
var SlidesWrapper = (0, _styledComponents["default"])(HideScrollbarX).withConfig({
  displayName: "styles__SlidesWrapper",
  componentId: "sc-n66423-4"
})(["flex-grow:1;"]);
exports.SlidesWrapper = SlidesWrapper;
var Dot = _styledComponents["default"].button.withConfig({
  displayName: "styles__Dot",
  componentId: "sc-n66423-5"
})(["border-radius:2px;transition:margin .3s,width .3s,height .3s,background-color .3s;background-color:", ";width:6px;height:6px;margin:0 5px;", ""], _colors.celesteApprox, function (props) {
  return props.active && (0, _styledComponents.css)(["background-color:", ";width:8px;height:8px;margin:0 4px;"], _colors.thdOrange);
});
exports.Dot = Dot;
var Dots = (0, _styledComponents["default"])(CenterContent).withConfig({
  displayName: "styles__Dots",
  componentId: "sc-n66423-6"
})(["min-height:8px;"]);
exports.Dots = Dots;
var DotCarouselRoot = _styledComponents["default"].div.withConfig({
  displayName: "styles__DotCarouselRoot",
  componentId: "sc-n66423-7"
})(["display:flex;flex-direction:column;min-width:295px;min-height:295px;", " ", ""], function (props) {
  return (props.scrollMode === 'discrete' || props.scrollMode === 'peek') && (0, _styledComponents.css)(["", "{scroll-snap-type:x mandatory;}", "{scroll-snap-align:center;}"], Slides, Slide);
}, function (props) {
  return props.scrollMode === 'discrete' && (0, _styledComponents.css)(["", "{min-width:100%;}"], Slide);
});
exports.DotCarouselRoot = DotCarouselRoot;
//# sourceMappingURL=styles.js.map